<mat-card [@snFadeInDown] [class.registry]="isRegistry">
  <div [class.auth-row]="isRegistry">
    <div *ngIf="isRegistry" class="auth-col-lg-9 auth-col-md-8 auth-d-none auth-d-sm-none auth-d-md-block registry-info">
      <div
        class="dynamic-bg"
        fxflex=""
        fxhide=""
        fxshow.gt-xs=""
        id="login-intro"
        [ngStyle]="{'background' : 'linear-gradient( rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(' + organization?.backgroundUrl + ') no-repeat', 'background-size': 'cover'}"
      >
        <div class="title ng-trigger ng-trigger-animate">
          {{ organization?.displayName }}'s Camera Registry
        </div>
        <div *ngIf="organization.registryContent" class="description">
          <p [innerHTML]="organization.registryContent"></p>
          <div class="video-container">
            <video width="520" height="440" controls *ngIf="this.organization.loginVideoUrl">
              <source [src]="this.organization.loginVideoUrl" type="video/mp4" />
            </video>
          </div>
        </div>
        <div *ngIf="!organization.registryContent">
          <div class="description">
            Registering your security cameras with {{ organization?.displayName }}'s registry allows
            the department to quickly and efficiently investigate incidents that may have occurred
            in and around your location. Your support of this program will help the department keep
            our community safe for all of its citizens.
          </div>
          <div class="description">
            <ul>
              <li>Registration typically takes under 5 minutes</li>
              <li>
                The information you provide is accessible only by authorized law enforcement
                personnel
              </li>
              <li>
                The information will only be shared with public safety personnel, not third parties
              </li>
              <li>
                Helps investigators to request recorded video of criminal incidents, to assist in
                investigations
              </li>
            </ul>
          </div>
          <div class="video-container">
            <video width="520" height="440" controls *ngIf="this.organization.loginVideoUrl">
              <source [src]="this.organization.loginVideoUrl" type="video/mp4" />
            </video>
          </div>
        </div>
      </div>
    </div>
    <div
      [ngClass]='{"auth-col-lg-3":isRegistry, "auth-col-md-4":isRegistry, "auth-col-sm-12": isRegistry}'
      class="login-form"
    >
      <form
        class="auth-text-center"
        [formGroup]="form"
        (ngSubmit)="showPassword ? onFormSubmit() : checkEmail()"
      >
        <ng-template
          [ngIf]="organization?.logoUrl && signinAllowed"
          [ngIfThen]="customLogoTml"
          [ngIfElse]="fususVaultLogoTml"
        >
        </ng-template>

        <sn-alert dense class="auth-rounded-0 auth-text-left auth-mt-sm" type="danger" *ngIf="form.errors">
          {{ getErrors() }}
        </sn-alert>

        <main class="auth-p-sm" *ngIf="form && signinAllowed">
          <h3>{{ 'auth.signIn.title' | t }}</h3>
          <sn-sign-in-form
            [showingPassword]="showPassword"
            [form]="form"
            [formModel]="formModel"
          ></sn-sign-in-form>
          <div class="auth-mt-nsm auth-text-right position-relative">
            <a
              [routerLink]="['/auth', 'reset']"
              [queryParams]="{ email: formModel.email }"
              tabindex="-1"
              >{{ 'common.forgotPassword' | t }}</a
            >
          </div>
        </main>

        <div class="registration-description" *ngIf="!signinAllowed">
          <p>Registry Is Not Enabled</p>
        </div>

        <mat-card-actions *ngIf="signinAllowed" class="auth-flex-column">
          <button
            mat-raised-button
            color="accent"
            [disabled]="isRedirecting"
            [mtBasicSpinner]="isLoading"
            [hideText]="true"
          >
            {{ buttonMessage | t }}
          </button>
          <ng-container>
            <div class="auth-d-flex auth-align-items-center auth-m-4">
              <mat-divider class="flex-fill"></mat-divider>
            <div class="mx-2">{{ 'common.or' | t }}</div>
              <mat-divider class="flex-fill"></mat-divider>
            </div>
            <a mat-button class="sign-in-with-axon-button auth-mx-0" [href]="axonSsoUrl">
              <div class="auth-d-flex auth-justify-content-center auth-align-items-center">
                <sn-icon fontSet="fs" fontIcon="Icon_Axon" class="mr-1" size="sm"></sn-icon>
              {{ 'auth.signIn.signInWithAxon' | t }}
              </div>
            </a>
            <p class="muted-text auth-mt-xs auth-mb-0">{{ 'auth.signIn.notAvailableToAllAgencies' | t }}</p>
          </ng-container>
        </mat-card-actions>

        <footer class="pb-sm pt-xs" *ngIf="signUpEnabled">
            {{ 'auth.signIn.notAMember' | t }}
            <a [routerLink]="['/auth', 'sign-up']">{{ 'auth.signIn.signUpNow' | t }}</a>
        </footer>
      </form>
      <div>
        <p class="version">
          {{ version }}<span *ngIf="backendVersion"> / {{ backendVersion }}</span>
        </p>
      </div>
      <div *ngIf="organization?.prefix" class="fusus-logo-login">
        <a href="https://fusus.com" target="_blank"
          ><img src="assets/images/logos/powered-by-fusus-logo.png"
        /></a>
      </div>
    </div>
  </div>
</mat-card>
<ng-template #fususVaultLogoTml>
  <sn-brand-logo
    class="brand-logo__margin-vertical-md brand-logo__padding-top-md"
    type="horizontal"
  ></sn-brand-logo>
</ng-template>

<ng-template #customLogoTml>
  <img class="logo" [src]="organization?.logoUrl" />
</ng-template>
